export interface TermsOfUseContent {
  heading?: string; // 소제목 (ex. 제1조 목적)
  subHeading?: string;
  description: string[]; // 본문 내용 (줄바꿈을 위해 배열로 처리)
}

export interface TermsOfUseSection {
  title: string; // 섹션 제목 (ex. 제 1장 총칙)
  subHeading?: string;
  content: TermsOfUseContent[]; // 섹션 내 상세 내용
}

export interface PrivacyPolicyCell {
  value: string; // 셀의 값
  colSpan?: number; // 가로 병합
  rowSpan?: number; // 세로 병합
}

export interface PrivacyPolicyRow {
  cells: PrivacyPolicyCell[]; // 모든 컬럼 데이터
}

export interface PrivacyPolicyTable {
  title?: string; // 테이블 제목
  headers: string[]; // 테이블 헤더
  rows: PrivacyPolicyRow[]; // 테이블 행 리스트
}

export interface PrivacyPolicySubSection {
  subTitle: string; // 소섹션 제목
  content?: string | string[]; // 설명 내용 (단락 또는 리스트)
  subList?: string[]; // 번호 있는 리스트 항목
  table?: PrivacyPolicyTable; // 테이블 포함 가능
}

export interface PrivacyPolicySection {
  title?: string; // 섹션 제목
  numberedList?: string[]; // 순번 있는 리스트 (1, 2, 3 등)
  subSections?: PrivacyPolicySubSection[]; // 하위 섹션 리스트
}

// 약관 관련 신규 ui
export enum TermsNameType {
  TERMS_OF_SERVICE = 'terms-of-service',
  PERSONAL_INFO_COLLECTION = 'personal-info-collection',
  PERSONAL_INFO_PROCESSING = 'personal-info-processing',
  LOCATION_INFO_COLLECTION = 'location-info-collection',
}

export interface TermsTabType {
  titles: TermsTabTitleType[];
}

export interface TermsTabTitleType {
  title: string;
  termsName: TermsNameType;
}

export interface TermsDataType {
  title?: string; // 약관 제목
  title1?: string; // 제x장
  title2?: string; // 제x조
  discription1?: string; // 일반 텍스트(탭x)
  discription2?: string[][]; // 탭1 + 문자 + 텍스트
  discription3?: string[][]; // 탭2 + 문자 + 텍스트
  table?: TermsTableDataType;
  lineBreak?: boolean;
}

export interface TermsTableDataType {
  title?: string; // 테이블 제목
  headers: TermsTableHeaderType[]; // 테이블 헤더
  rows: TermsTableRowType[]; // 테이블 행 리스트
}

export interface TermsTableHeaderType {
  title: string;
  colSpan?: number;
}

export interface TermsTableRowType {
  cells: TermsCellType[]; // 모든 컬럼 데이터
}

export interface TermsCellType {
  value: string; // 셀의 값
  colSpan?: number; // 가로 병합
  rowSpan?: number; // 세로 병합
}
